import { Skeleton } from '@radix-ui/themes';

import { DeploymentCardSkeleton } from './DeploymentCard/DeploymentCardSkeleton';

const DeploymentsSkeleton = () => {
  return (
    <div
      className='flex flex-col gap-fly-5'
      data-testid='runtime-environment-deployments-skeleton'
    >
      <Skeleton className='h-8 my-fly-7 w-full rounded-fly-4' />
      <DeploymentCardSkeleton isFirst />
      <DeploymentCardSkeleton isLast />
    </div>
  );
};

export default DeploymentsSkeleton;
